import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "disabled"]

import {
  ref,
  useAttrs,
  withDefaults,
  watch,
} from "vue";
import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";

interface Props {
  modifires?: typeModifires;
  name?: string;
  disabled?: boolean;
  value?: string;
  fontSize?: string;
  height?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'select-item',
  props: {
    modifires: { type: [String, Array, Boolean] },
    name: {},
    disabled: { type: Boolean },
    value: {},
    fontSize: { default: "1.2rem" },
    height: { default: "26px" }
  },
  emits: ["update"],
  setup(__props: any, { emit }) {

const props = __props;


const attrs = useAttrs();

const selectTag = ref(null);

watch(
  () => props.value,
  () => {
    const options = (selectTag.value! as HTMLSelectElement)?.options;
    if (!options) return;
    const optionTags = Array.from(options);
    optionTags.forEach((option) => {
      if (option.value.toString() === props.value?.toString()) {
        option.selected = true;
      }
    });
  },
  { immediate: true }
);

const handleChange = (e: Event) => {
  emit("update", (e.target as HTMLInputElement).value);
};

const componentClass = () =>
  mapModifires(
    "select-item",
    mergeModifires(props.modifires, props.disabled && "disabled")
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass()),
    style: _normalizeStyle({ height: _ctx.height })
  }, [
    _createElementVNode("select", {
      ref_key: "selectTag",
      ref: selectTag,
      class: "select-item__select",
      name: props.name,
      style: _normalizeStyle({ fontSize: _ctx.fontSize, height: _ctx.height }),
      disabled: props.disabled,
      onChange: handleChange
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 44, _hoisted_1)
  ], 6))
}
}

})